import { Edit } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { editProduct } from '../../../api/products';
import Modal from '../../elements/Modal';
import ProductForm from './ProductForm';
import useAuthToken from '../../../hooks/getUserData';

export default function EditProduct({
  product,
  fetchData,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [productData, setProductData] = useState({});
  const [error, setError] = useState(null);

  const token = useAuthToken();

  useEffect(() => {
    setProductData({ ...product });
  }, [product]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  const handleEditForm = async (values) => {
    const priceWithoutCommas = values.price.replace(/,/g, '');
    
    const payload = {
        ...values,
        title: values.title,
        price: priceWithoutCommas, 
    };
    try {
      const response = await editProduct(payload, product.id, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Product updated successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(
        error.message || 'An error occurred while updating product data.'
      );
    }
  };

  return (
    <>
      <IconButton variant="text" onClick={handleClickOpen}>
        <Edit />
      </IconButton>
      <Modal
        open={open}
        width={'sm'}
        modalTitle="Edit Product"
        handleClose={handleClose}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <ProductForm
          product={productData}
          onSubmit={handleEditForm}
          token={token}
        />
      </Modal>
    </>
  );
}
